export default __webpack_public_path__ + "static/iconfinder_28_3319616-509b546afdcc72c2fe08d60103ba0d94.png";